/** Console shell wiring, guards, permission states (P3). */
export const consoleShell = {
  loadingSession: "Signing you in…",
  sessionErrorTitle: "We couldn't reach Sagot",
  sessionErrorBody: "Check your connection, then try again. Your work is safe.",
  roleLine: "{{title}} · {{role}}",
  planLine: "{{plan}} plan · {{industry}}",
  planOnly: "{{plan}} plan",
  noNotificationsTitle: "You're all caught up",
  noNotificationsBody: "New handoffs, finished uploads and knowledge gaps show up here.",
  notificationsError: "Notifications couldn't load.",
  justNow: "Just now",
  agentsUnavailable: "Agent switching arrives with the Agents module.",
  chooseAgent: "Choose an agent first",
  paletteActions: "Actions",
  palettePages: "Pages",
  paletteWorkspaces: "Workspaces",
  paletteSignOut: "Sign out",
  paletteRoles: "Roles & permissions",
  paletteToggleTheme: "Switch to {{theme}} theme",
  signedOut: "You're signed out",
  impersonationTitle: "Support view",
  impersonationBody: "You're viewing {{workspace}} as CRUD.IT staff. Every action is logged.",
  impersonationReadOnly: "Read-only",
  impersonationEnds: "Ends {{time}}",
  impersonationEnd: "End session",
  impersonationEnded: "Support session ended",
  readOnlyTooltip: "Read-only in this session",
  noPermission: "You don't have permission to do this",
  forbiddenTitle: "You don't have access to this page",
  forbiddenBody: "Your role in {{workspace}} doesn't include this page. Ask a workspace Owner or Admin if you need access.",
  forbiddenBodyNoWorkspace: "Ask a workspace Owner or Admin if you need access.",
  noWorkspaceTitle: "This workspace isn't available",
  noWorkspaceBody: "You may have been removed from it, or the link is wrong.",
  goHome: "Go to my workspace",
  roles: {
    owner: "Owner",
    admin: "Admin",
    editor: "Editor",
    agent: "Agent",
    viewer: "Viewer",
    field_engineer: "Field engineer",
    sales: "Sales",
  },
  plans: {
    starter: "Starter",
    standard: "Standard",
    pro: "Pro",
    institution: "Institution",
    trial: "Trial",
  },
  industries: {
    education: "Education",
    school: "Education",
    healthcare: "Healthcare",
    clinic: "Healthcare",
    real_estate: "Real estate",
    hospitality: "Hospitality",
    government: "Government",
    human_resources: "HR",
    ecommerce: "E-commerce",
    retail: "E-commerce",
    business: "Business",
    general: "Business",
    other: "Organization",
  },
} as const;
